module.exports = __webpack_public_path__ + "img/mt_logo.dcc24243.svg";